import { Component } from '@angular/core';
import { PAGE_NAME } from 'app/shared/generic-grid/types/page-name.constants';

@Component({
	selector: 'app-contact-list',
	templateUrl: './contact.component.html',
	styleUrls: ['./contact.component.scss'],
	standalone: false
})
export class ContactComponent {
	readonly PAGE_NAME = PAGE_NAME;
}
